import Dashboard from "../../views/dashboard/Dashboard.vue";

const advertisement = {
  path: "/advertisementmanagement",
  name: "advertisementmanagement",
  redirect: "advertisementput",
  component: Dashboard,
  meta: {
    title: "公告管理",
    icon: "el-icon-mobile",
    role: false
  },
  children: [
    {
      path: "/advertisementput",
      name: "advertisementput",
      component: () =>
        import("../../components/advertisementmanagement/advertisementput.vue"),
      meta: {
        title: "公告投放",
        icon: "el-icon-folder-checked",
        role: false
      }
    },
    {
      path: "/advertisementexamine",
      name: "advertisementexamine",
      component: () =>
        import(
          "../../components/advertisementmanagement/advertisementexamine.vue"
        ),
      meta: {
        title: "广告投放",
        icon: "el-icon-s-release",
        role: false
      }
    },
    {
      path: "/companycarousel",
      name: "companycarousel",
      component: () =>
        import("../../components/advertisementmanagement/companycarousel.vue"),
      meta: {
        title: "企业轮播",
        icon: "el-icon-video-play",
        role: false
      }
    }
  ]
};

export default advertisement;
